/** @format */

import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../context/DataContext";
import Footer from "../components/Footer";

/* Begin By Javi */
import Header from "./Header";
import { Loader } from "../util/loader";
import utils from "./../util";
import { apiEstudiante } from "../api";
/* End By Javi */

const { isMobile } = utils;
export const Estudiante = () => {
  /* Begin By Javi */
  const [Loading, setloading] = useState(true);
  const [alertMessage, setMessage] = useState("Estudiantes UPN");
  /* End By Javi */
  const { data, setData } = useContext(DataContext);
  const [_isMobile] = useState(isMobile());
  const [listStudents, setListStudents] = useState([]);

  function capitalizarPrimeraLetra(str) {
    let result = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    return result;
  }
  useEffect(async () => {
    var arrayStudent = [];
    const dataUser = JSON.parse(localStorage.getItem("userLogin"));
    const headers = {
      Authorization: dataUser.detail.Security.Token,
    };

    // create a promise for the axios request
    /* Begin By Javi */
    const promise = apiEstudiante.listar(
      dataUser.detail.apoderado_id,
      alertMessage
    );
    promise.then((res) => {
      if (res != undefined) {
        res.forEach((student) => {
          console.log("arrayStudent", res);
          arrayStudent.push({
            Codigo: student.codigo,
            Nombres: capitalizarPrimeraLetra(student.nombres),
            Carrera: student.carrera,
            Programa: "",
            Foto: student.Foto,
          });
        });
        setloading(false);
        setListStudents(arrayStudent);
        setData({ ...data, students: arrayStudent });
        localStorage.setItem("studientList", JSON.stringify(arrayStudent));
        setTimeout(
          arrayStudent.length == 1
            ? (localStorage.setItem(
                "studientActive",
                JSON.stringify(arrayStudent)
              ),
              ChangeStudentHandler(
                arrayStudent[0].Codigo,
                arrayStudent[0].Nombres,
                arrayStudent[0].Carrera,
                arrayStudent[0].Ciclo,
                arrayStudent[0].Foto
              ),
              (window.location.href = "./curso"))
            : localStorage.setItem(
                "studientList",
                JSON.stringify(arrayStudent)
              ),
          500
        );
      } else {
        setloading(false);
      }
    });
    /* End By Javi */
  }, [setListStudents]);

  const ChangeStudentHandler = (Codigo, Nombres, Carrera, Ciclo, Foto) => {
    const objStudent = {
      Codigo: Codigo,
      Nombres: Nombres,
      Carrera: Carrera,
      Ciclo: Ciclo,
      courseSection: 123,
      Foto: Foto,
    };
    setData({ ...data, student: objStudent });
    setTimeout(
      localStorage.setItem("studientActive", JSON.stringify(objStudent)),
      2000
    );
  };
  return (
    <div>
      {Loader(Loading)}
      {_isMobile ? (
        <>
          <div className="contend">
            <div className="text col-12">
              <Header
                objData={data}
                page={"E"}
                objlistStudents={listStudents}
                ChangeStudentHandler={ChangeStudentHandler}
                isMobile={_isMobile}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="contend">
            <div className="text col-12">
              <Header
                objData={data}
                page={"E"}
                objlistStudents={listStudents}
                ChangeStudentHandler={ChangeStudentHandler}
                isMobile={_isMobile}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
